<template>
    <div>
        <buttonlist
                @help="help"
                @reflash="reflash"
                ref="SetBtn"
        ></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left1" ref="left1">
                <el-table
                        id="xpane-0"
                        :data="dataSet"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight"
                        @row-click="getGantt"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection" v-if="false"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                    <el-table-column prop="Plan_Finish_date"
                                     :label="$t('getapi[6162]')">
                        <template slot-scope="scope">
                            <span>{{scope.row.Plan_Finish_date | toDate}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip prop="end_time" :label="$t('getapi[6351]')"></el-table-column>
                    <el-table-column :label="$t('getapi[6350]')" width="60">
                        <template slot-scope="scope">
                            <span>{{getDays(scope.row.end_time,scope.row.Plan_Finish_date)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid1" ref="mid1">
                <div>
                    <tr>
                        <td style="width:50px">{{$t('getapi[7175]')}}</td>
                        <td style="width:250px">
                            <el-radio-group v-model="scale" size="mini" @change="wekk">
                                <el-radio-button :label="$t('getapi[7176]')"></el-radio-button>
                                <el-radio-button :label="$t('getapi[7177]')"></el-radio-button>
                                <el-radio-button :label="$t('getapi[7178]')"></el-radio-button>
                            </el-radio-group>
                        </td>
                        <td style="width:50px">{{$t('getapi[4285]')}}</td>
                        <td style="width:150px">
                            {{code}}
                        </td>
                       <!-- <td>{{'开始日期'}}</td>
                        <td>
                            <el-date-picker v-model="s_date" type="date"></el-date-picker>
                        </td>
                        <td>{{'结束日期'}}</td>
                        <td>
                            <el-date-picker v-model="e_date" type="date"></el-date-picker>
                        </td>-->
                    </tr>
                </div>
                <div class="app-container" style="margin-top: 5px">
                    <div ref="gantt" id="gant"></div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import {gantt} from 'dhtmlx-gantt'
    export default {
        name: '2_overduelist',
        component: {gantt},
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                tableHeight: Common.tableHeight3, // 主表高度
                tasks:{
                    data: [
                    ]
                },
                scale: '按天',
                startDate: this.getMonth()[0],
                endDate: this.getMonth()[1],
                code: '',
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.$limits.dragControllerDiv1();
            that.getView()
            that.getSetting()
            that.authority();
        },
        methods: {
            getSetting() {
                let that = this
                // 获取当前月的第一天
                let start = new Date();
                start.setDate(1);
                // 获取当前月的最后一天
                let date = new Date();
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let end = new Date(nextMonthFirstDay - oneDay);
                that.startDate = that.transferDate(start); // 日期变换
                that.endDate = that.transferDate(end); // 日期变换
                gantt.i18n.setLocale('cn') // 国际化
                gantt.config.xml_date = "%Y-%m-%d %H:%i:%s";
                gantt.config.min_column_width = 20; //设置时间线区域中列的最小宽度
                gantt.config.duration_unit = "minute"; //拖动持续时间单位
                gantt.templates.tooltip_text = function (start, end, task) {
                    return '<b>工序名称:</b> ' + task.text + '<br/><b>工作时间:</b> ' + new Date(start).getHours()+':'+new Date(start).getMinutes()+':'+new Date(start).getSeconds()+' - '+ new Date(end).getHours()+':'+new Date(end).getMinutes()+':'+new Date(end).getSeconds()
                }
                gantt.config.duration_step = 1
                gantt.plugins({
                     marker: true
                });
                gantt.setWorkTime({
                    hours: ["0:00-23:59"]
                }); //global working hours
                gantt.setWorkTime({
                    day: 6,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 0,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 1,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 2,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 3,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 4,
                    hours: true
                });
                gantt.setWorkTime({
                    day: 5,
                    hours: true
                });
                gantt.config.scales = [{
                    unit: "month",
                    step: 1,
                    format: "%Y %M"
                },
                    {
                        unit: "day",
                        step: 1,
                        format: "%d"
                    },
                ];
                gantt.templates.timeline_cell_class = function (item, date) {
                    if (date.getDay() == 0 || date.getDay() == 6) {
                        return 'weekend';
                    }
                };
                gantt.config.details_on_dblclick = true
                gantt.plugins({ // 提示信息
                    tooltip: true// 启用 tooltip 插件
                })
                gantt.attachEvent('onTaskDblClick', function (id, e) {
                    //点击左侧任务列表不弹窗
                    if(e.target.getAttribute('class') == 'gantt_tree_content'){
                        return false
                    }
                    return true;
                });
                gantt.serverList("priority", [{
                    key: 1,
                    label: "锁定",
                    backgroundColor: "#ff0000",
                    textColor: "#FFF"
                },
                    {
                        key: 2,
                        label: "正常",
                        backgroundColor: "#03A9F4",
                        textColor: "#FFF"
                    },
                    {
                        key: 3,
                        label: "已完工",
                        backgroundColor: "#55aa00",
                        textColor: "#FFF"
                    },
                    {
                        key: 4,
                        label: "进行中",
                        backgroundColor: "#aaff00",
                        textColor: "#FFF"
                    }
                ]);
                gantt.locale.labels.column_so_code = gantt.locale.labels.section_so_code = "工单号";
                gantt.locale.labels.column_cut_no = gantt.locale.labels.section_cut_no = "切分号";
                gantt.locale.labels.column_routing_sequence_no = gantt.locale.labels.section_routing_sequence_no = "工序号";
                gantt.locale.labels.column_start_time = gantt.locale.labels.section_start_time = "开始时间";
                gantt.locale.labels.column_end_time = gantt.locale.labels.section_end_time = "结束时间";
                gantt.locale.labels.column_gongshi = gantt.locale.labels.section_gongshi = "工期（分钟）";
                gantt.locale.labels.column_plan_finish_qty = gantt.locale.labels.section_plan_finish_qty = "计划数";
                gantt.locale.labels.column_finish_qty = gantt.locale.labels.section_finish_qty = "完工数";
                gantt.locale.labels.column_r_name = gantt.locale.labels.section_r_name = "状态";
                gantt.config.lightbox.sections = [{
                    name: "so_code",
                    height: 30,
                    map_to: "r_code",
                    type: "textarea",
                    focus: true,
                },
                    {
                        name: "cut_no",
                        height: 30,
                        map_to: "cut_no",
                        type: "textarea",
                    },
                    {
                        name: "routing_sequence_no",
                        height: 30,
                        map_to: "routing_sequence_no",
                        type: "textarea",
                    },
                    {
                        name: "start_time",
                        height: 30,
                        type: "textarea",
                        map_to: "start_date",
                    },
                    {
                        name: "end_time",
                        height: 30,
                        type: "textarea",
                        map_to: "end_date",
                        readonly: true
                    },
                    {
                        name: "gongshi",
                        height: 30,
                        map_to: "duration",
                        type: "textarea",
                    },
                    {
                        name: "plan_finish_qty",
                        height: 30,
                        map_to: "plan_finish_qty",
                        type: "textarea",
                    },
                    {
                        name: "finish_qty",
                        height: 30,
                        map_to: "finish_qty",
                        type: "textarea",
                    },
                    {
                        name: "r_name",
                        height: 30,
                        map_to: "r_name",
                        type: "textarea",
                        readonly: true,
                    },
                ];
                gantt.attachEvent("onParse", function () {
                    var styleId = "dynamicGanttStyles";
                    var element = document.getElementById(styleId);
                    if (!element) {
                        element = document.createElement("style");
                        element.id = styleId;
                        document.querySelector("head").appendChild(element);
                    }
                    var html = [];
                    var resources = gantt.serverList("priority");
                    console.log('resource' + JSON.stringify(resources))
                    resources.forEach(function (r) {
                        html.push(".gantt_task_line.gantt_resource_" + r.key + "{" +
                            "background-color:" + r.backgroundColor + "; " +
                            "color:" + r.textColor + ";" +
                            "}");
                    });
                    element.innerHTML = html.join("");
                });
                gantt.templates.grid_row_class =
                    gantt.templates.task_row_class =
                        gantt.templates.task_class = function (start, end, task) {
                            var css = [];
                            if (task.$virtual || task.type == gantt.config.types.project)
                                css.push("summary-bar");

                            if (task.priority) {
                                css.push("gantt_resource_task gantt_resource_" + task.priority);
                            }
                            return css.join("");
                        };
                //左侧显示列名
                gantt.config.columns = [
                    {name: "routing_sequence_no", label: "工序", align: "center", width: 60,},
                    {name: "text", label: "工序名称", align: "center", width: 90,},
                    {name: "start_date", label: "开始时间", align: "center", width: 90,},
                    {name: "duration", label: "工时(分)", align: "center", width: 60,},
                    {
                        name: "progress", label: "完成率", align: "center", width: 60,
                        template: function (item) {
                            if (item.progress >= 1)
                                return '<span style="display:inline-block;width:100%">100%</span>';
                            if (item.progress == 0)
                                return '<span style="display:inline-block;width:100%">0%</span>';
                            return '<span style="display:inline-block;width:100%">' + Math.round(item
                                .progress * 100) + '%</span>';
                        }
                    },
                ];
                gantt.config.tooltip_hide_timeout = 2000;
                gantt.init(this.$refs.gantt, new Date(this.getMonth()[0]), new Date(this.getMonth()[1]));
                gantt.parse(that.tasks);
            },
            changeScales(e) {
                if (e == 0) {
                    gantt.config.scales = [{
                        unit: "day",
                        step: 1,
                        format: "%Y %M %d %l"
                    },
                        {
                            unit: "hour",
                            step: 1,
                            format: "%G"
                        },
                    ];
                }
                if (e == 1) {
                    gantt.config.scales = [{
                        unit: "month",
                        step: 1,
                        format: "%Y %M"
                    },
                        {
                            unit: "day",
                            step: 1,
                            format: "%d"
                        },
                    ];
                }
                if (e == 2) {
                    gantt.config.scales = [{
                        unit: "day",
                        step: 1,
                        format: "%Y %M %d 日 %l"
                    },
                        {
                            unit: "hour",
                            step: 1,
                            format: "%G"
                        },
                        {
                            unit: "minute",
                            format: this.monRangeFormat(15),
                            step: 15
                        }
                    ];
                }
                gantt.render();
            },
            monRangeFormat(step) {
                let monToStr = gantt.date.date_to_str("%i")
                return function (date) {
                    var intervalEnd = new Date(gantt.date.add(date, step, "minute") - 1)
                    //return monToStr(date) + " - " + monToStr(intervalEnd);
                    return monToStr(intervalEnd);
                };
            },
            getMonth(Fn) {
                let that = this
                // 获取当前月的第一天
                let start = new Date();
                start.setDate(1);
                // 获取当前月的最后一天
                let date = new Date();
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let end = new Date(nextMonthFirstDay - oneDay);
                let startDate = that.transferDate(start); // 日期变换
                let endDate = that.transferDate(end); // 日期变换
                let times = [];
                times.push(startDate);
                times.push(endDate);
                return times;
            },
            transferDate(date) {
                // 年
                let year = date.getFullYear();
                // 月
                let month = date.getMonth() + 1;
                // 日
                let day = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                let dateString = year + '-' + month + '-' + day;
                return dateString;
            },
            changetime(timed) {
                let time = new Date(timed);
                let y = time.getFullYear();
                let m = time.getUTCMonth() + 1;
                let d = time.getDate();
                let h = time.getHours();
                let s = time.getMinutes();
                let times = d + "-" + m + "-" + y + " " + h + ":" + s;
                return times
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6594]"),this.$t("getapi[8049]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('refresh');
            },
            leftt(e) {
                var left = document.getElementsByClassName('left1');
                var mid = document.getElementsByClassName('mid1');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            /*// 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SysWorkCalendarLineViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.isVisible = false;
                that.getView();
            },*/
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/Aps/APSOverdueList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 日期相减
            getDays(day1, day2) {
                let that = this
                let a1 = Date.parse(new Date(day2));
                let a2 = Date.parse(new Date(day1));
                let day = parseInt((a2 - a1) / (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
                return day
            },
            /*// 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Basic/WH/GetCalendarLineToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },*/
            getGantt(row){
                let that = this
                gantt.clearAll()
                that.code = row.so_code
                that.tasks.data = [];
                let parm = {
                    so_code: row.so_code,
                    r_code: '',
                    s_date: that.startDate,
                    e_date: that.endDate,
                    flg: 0
                }
                that.$http.urlpost('/Pro/Aps/APSList', parm, function (res) {
                    if (res.Success == 1) {
                        let data = []
                        let arr = res.DataContent.Lines
                        for (let i = 0; i < arr.length; i++) {
                            let ff = (arr[i].finish_qty / arr[i].plan_finish_qty).toFixed(2);
                            let lock = arr[i].lock_schedule;
                            let finish_flag = arr[i].finish_flag;
                            let s_flag = arr[i].s_flag;
                            let pro = 0;
                            let rname = ''
                            if (finish_flag == 1) {
                                pro = 3;
                                rname = '已完工'
                            } else {
                                if (lock == 0) {
                                    if (s_flag == 1) {
                                        pro = 4;
                                        rname = '进行中'
                                    } else {
                                        pro = 2;
                                        rname = '正常';
                                    }

                                } else {
                                    pro = 1;
                                    rname = '锁定'
                                }
                            }
                            data = [...data, {
                                id: i + 2,
                                r_code: arr[i].r_code,
                                text: arr[i].r_code,
                                start_date: arr[i].start_time,
                                end_date: arr[i].end_time,
                                duration: arr[i].gongshi,
                                progress: ff,
                                parent: 1,
                                render: 'split',
                                open: true,
                                users: arr[i].r_code,
                                so_code: arr[i].so_code,
                                routing_sequence_no: arr[i].routing_sequence_no,
                                priority: pro,
                                plan_finish_qty:arr[i].plan_finish_qty,
                                finish_qty:arr[i].finish_qty,
                                r_name: rname,
                                sdate: arr[i].start_time,
                                edate: arr[i].end_time
                            }]
                        }
                        let jsons = []
                        for (let i = 0; i < data.length; i++) {
                            jsons = [...jsons, {
                                id: i + 10000,
                                routing_sequence_no: data[i].routing_sequence_no,
                                r_code: data[i].r_code,
                                text: data[i].text,
                                start_date: data[i].start_date,
                                duration: data[i].duration,
                                progress: data[i].progress,
                                users: data[i].users,
                                priority: 2,
                                render: 'split',
                                plan_finish_qty:data[i].plan_finish_qty,
                                finish_qty:data[i].finish_qty,
                                r_name: data[i].r_name,
                            }]
                        }
                        jsons.sort(that.compare('routing_sequence_no'))
                        gantt.config.start_date = new Date(that.startDate);
                        gantt.config.end_date = new Date(that.endDate);
                        gantt.addMarker({
                            start_date: new Date(),
                            text: '今日'
                        });
                        gantt.init(that.$refs.gantt);
                        console.log(jsons)
                        that.tasks.data = jsons
                        that.tasks.links = [];
                        gantt.parse(that.tasks)
                    }
                });
            },
            compare(property){
                return function(a,b){
                    var value1 = a[property];
                    var value2 = b[property];
                    return value1 - value2;
                }
            },
            // 4.获取本月日期
            // 刻度切换
            wekk(e) {
                let that = this
                if (e == '按小时') {
                    that.changeScales(0);
                }
                if (e == '按天') {
                    that.changeScales(1);
                }
                if (e == '按分钟') {
                    that.changeScales(2);
                }
            },
        }
    };
</script>

<style scoped lang="less">
    #gant{
        height:calc(100vh - 170px);
    }
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-radio-button--mini .el-radio-button__inner{
        padding: 2px 10px
    }
</style>
